<div id="ACMO-Cookie"></div>
<div class="cookieBtn" *ngIf="!isCookieDeclarationShown">
  <button mat-raised-button color="primary" (click)="showCookieDeclaration()">Show cookie declaration</button>
</div>